const actionTypes = {
  // PDF Preview
  SET_PDF_PREVIEW_URL: 'setPDFPreviewURL',
  SET_PDF_PREVIEW_ACTVIE_STATUS: 'setPDFPreviewActiveStatus',
}

export default actionTypes
